import React from "react"
import ReactDOM from "react-dom"
import MerchantListPage from "./merchant-list-page"

export default class MerchantListModule {
  constructor(elem) {
    this.elem = elem
    this.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.shopsPage = elem.dataset.shopsPage && JSON.parse(elem.dataset.shopsPage)
    this.diningPage = elem.dataset.diningPage && JSON.parse(elem.dataset.diningPage)
    this.taxfreePage = elem.dataset.taxfreePage && JSON.parse(elem.dataset.taxfreePage)
    this.init()
  }

  init() {
    const self = this

    const data = {
      shopsPage: self.shopsPage,
      diningPage: self.diningPage,
      taxfreePage: self.taxfreePage,
      dataUrl: self.elem.dataset.dataUrl,
      contentId: self.elem.dataset.contentId,
      shopsContentId: self.elem.dataset.shopsContentId,
      shopsUrl: self.elem.dataset.shopsUrl,
      diningContentId: self.elem.dataset.diningContentId,
      diningUrl: self.elem.dataset.diningUrl,
      taxfreeContentId: self.elem.dataset.taxfreeContentId,
      taxfreeUrl: self.elem.dataset.taxfreeUrl,
    }

    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<MerchantListPage {...self.modelJson} {...data} />, self.elem)
  }
}
